import { Phone, Mail, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-slate-900 text-white relative overflow-hidden" data-testid="contact-section">
      <div className="absolute inset-0 opacity-30" aria-hidden="true"
        style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.10) 1px, transparent 0)", backgroundSize: "26px 26px" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative grid md:grid-cols-2 gap-10 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-sky-400">Talk to us</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Prefer a quick call? <br />We're one ring away.
          </h2>
          <p className="mt-4 text-slate-300 max-w-md leading-relaxed">
            Share your requirement on call or WhatsApp and we'll get back with a clear quote.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <a href="tel:+919673522737" className="group rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-6 transition" data-testid="contact-call">
            <Phone className="h-6 w-6 text-sky-400" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-sky-400">Call Us</p>
            <p className="mt-1 font-display text-lg font-semibold text-white">+91 96735 22737</p>
          </a>
          <a href="https://wa.me/919673522737" target="_blank" rel="noreferrer" className="group rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-6 transition" data-testid="contact-whatsapp">
            <MessageCircle className="h-6 w-6 text-emerald-400" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-emerald-400">WhatsApp</p>
            <p className="mt-1 font-display text-lg font-semibold text-white">+91 96735 22737</p>
          </a>
          <a href="mailto:shreevallabh2737@gmail.com" className="sm:col-span-2 group rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-6 transition" data-testid="contact-email">
            <Mail className="h-6 w-6 text-sky-400" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-sky-400">Email</p>
            <p className="mt-1 font-display text-lg font-semibold text-white">shreevallabh2737@gmail.com</p>
          </a>
        </div>
      </div>
    </section>
  );
}
